<template>
<div style="display: flex;flex-direction: column;align-items: center;">
  <el-form label-position="right" label-width="100px" :inline="true" style="padding-top: 10px">
    <el-form-item :label="$t('makeSchedule.MfgAttLineScheduleForm.productionLineName')">
      <el-input class="el-input" v-model="this.schedule.lineName" :placeholder="$t('makeSchedule.MfgAttLineScheduleForm.productionLineName')" disabled />
    </el-form-item>
    <el-form-item :label="$t('makeSchedule.MfgAttLineScheduleForm.timeName')">
      <el-input class="el-input" v-model="this.schedule.schedule_name" :placeholder="$t('makeSchedule.MfgAttLineScheduleForm.timeName')" />
    </el-form-item>
    <el-form-item :label="$t('makeSchedule.MfgAttLineScheduleForm.workTime')">
      <el-time-picker
          v-model="this.schedule.work_begin_time"
          :placeholder="$t('makeSchedule.MfgAttLineScheduleForm.startTime')"
          format="HH:mm"
          value-format="HH:mm:ss"
      />
      <el-time-picker
          style="margin-left: 10px"
          v-model="this.schedule.work_end_time"
          :placeholder="$t('makeSchedule.MfgAttLineScheduleForm.endTime')"
          format="HH:mm"
          value-format="HH:mm:ss"
      />
      <el-button style="margin-left: 10px" type="primary" @click="addRestSchedule()">{{ $t('makeSchedule.MfgAttLineScheduleForm.addRest') }}</el-button>
    </el-form-item>
    <div v-for="item in this.restSchedules" :key="item.id">
    <el-form-item :label="$t('makeSchedule.MfgAttLineScheduleForm.restRemark')">
      <div style="display: flex;">
      <el-input v-model="item.rest_remark" :placeholder="$t('makeSchedule.MfgAttLineScheduleForm.restRemark')"/>
      <el-button style="margin-left: 10px" type="primary" @click="delRestSchedule(item.id)">{{ $t('makeSchedule.MfgAttLineScheduleForm.deleteRest') }}</el-button>
      </div>
    </el-form-item>
    <el-form-item :label="$t('makeSchedule.MfgAttLineScheduleForm.restTime')">
      <el-time-picker
          v-model="item.rest_begin_time"
          :placeholder="$t('makeSchedule.MfgAttLineScheduleForm.startTime')"
          format="HH:mm"
          value-format="HH:mm:ss"
      />
      <el-time-picker
          style="margin-left: 10px"
          v-model="item.rest_end_time"
          :placeholder="$t('makeSchedule.MfgAttLineScheduleForm.endTime')"
          format="HH:mm"
          value-format="HH:mm:ss"
      />
    </el-form-item>
    </div>
    <div style="text-align: center">
      <el-button v-if="this.type === 'add'" type="primary" @click="addSchedule()">保存</el-button>
      <el-button v-else type="primary" @click="updateSchedule()">保存</el-button>
    </div>
  </el-form>

</div>
</template>

<script>
export default {
  name: "MfgAttLineScheduleForm",
  props: {
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    setting: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data(){
    return{
      schedule:{},
      restSchedules:[],
      type:'add'
    }
  },
  methods:{
    addRestSchedule(){
      let restSchedule = {
        id:Date.now(),
        rest_begin_time:null,
        rest_end_time:null
      }
      this.restSchedules.push(restSchedule)
    },

    delRestSchedule(id){
      for (let i = this.restSchedules.length - 1; i >= 0; i--) {
        if (this.restSchedules[i].id === id){
          this.restSchedules.splice(i,1)
        }
      }
    },

    async addSchedule(){
      this.schedule.restSchedules = this.restSchedules
      let {data:res} = await this.$axios.post('/mfg/LineSchedule/addLineSchedule',this.schedule);
      if (res.code === 0){
        this.$message.success("添加成功！")
        this.setting.$fn.closeWindow()
        this.setting.$fn.reSearch()
      }else {
        this.$message.error(res.message)
      }
    },

    async updateSchedule(){
      this.schedule.restSchedules = this.restSchedules
      console.log(this.schedule)
      let {data:res} = await this.$axios.post('/mfg/LineSchedule/updateLineSchedule',this.schedule);
      if (res.code === 0){
        this.$message.success("修改成功！")
        this.setting.$fn.closeWindow()
        this.setting.$fn.reSearch()
      }else {
        this.$message.error(res.message)
      }
    },

    async getLineName(){
      let {data:res} = await this.$axios.post('/mfg/LineSchedule/getLineName',this.schedule.line_id);
      this.schedule.lineName = res.data
    },

    async getScheduleRest(){
      let {data:res} = await this.$axios.post('/mfg/LineSchedule/getScheduleRest',this.schedule.id);
      this.restSchedules = res.data
    }
  },
  created() {
    if (this.parentData.button_id === "mfg_boli_work_time_query"){
      this.schedule.line_id = '5';
    }
    if (this.parentData.button_id === "mfg_xingcai_work_time_query"){
      this.schedule.line_id = '4';
    }
    if (this.parentData.button_id === "mfg_zuli_work_time_query"){
      this.schedule.line_id = '3';
    }
    if (this.parentData.button_id === "mfg_jiagong_work_time_query"){
      this.schedule.line_id = '2';
    }
    if (this.parentData.button_id === "mfg_tuzhuang_work_time_query"){
      this.schedule.line_id = '1';
    }
    if (this.parentData.button_id === "mfg_work_time_update"){
      this.schedule = this.parentData
      this.type = 'update'
      this.getScheduleRest()
    }
    this.getLineName()
    console.log(this.parentData)
  }
}
</script>

<style scoped>

</style>